import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import FieldDefault from './field-default';
import ColorBlock from './color-block';

import IconClose from '../icons/icon-close';

class LabelSelector extends PureComponent { 
    state = {
        searchTerm: ''
    }

    handleSearchChange = searchTerm => {
        this.setState({ searchTerm });
    }

    render() {
        const { t, withEdit } = this.props;
        const labels = this.props.labels.filter(label => (label.name || '').toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1);

        const defaultLabels = labels.filter(label => label.default);
        const customLabels = labels.filter(label => !label.default);

        return (
            <React.Fragment>
                <div className="popout-head">
                    { t('Tags') }

                    <button className="btn btn-icon btn-small popout-close" onClick={this.props.onClose}>
                        <IconClose />
                    </button>
                </div>

                <div className="popout-body">
                    <div className="label-body">
                        <FieldDefault
                            small={true}
                            placeholder={ t('Search tags') }
                            value={this.state.searchTerm}
                            autoFocus={true}
                            onChange={this.handleSearchChange}
                        />

                        <div className={'label-picker-options' + (this.props.loading ? ' loading' : '')}>
                            {
                                defaultLabels.length ? <div className="field-label dark">{ t('Default Tags') }</div> : null
                            }

                            {
                                defaultLabels.map(label => <ColorBlock
                                    key={label.id}
                                    id={label.id}
                                    color={label.color}
                                    name={ t(`items.${label.name}`) }
                                    selected={this.props.assignedLabels?.includes(label.id)}
                                    onClick={this.props.onLabelClick}
                                />)
                            }

                            {
                                defaultLabels.length && customLabels.length ? <div className="field-label dark">{ t('Custom Tags') }</div> : null
                            }

                            {
                                customLabels.map(label => <ColorBlock
                                    key={label.id}
                                    id={label.id}
                                    color={label.color}
                                    name={label.name}
                                    selected={this.props.assignedLabels?.includes(label.id)}
                                    onEditClick={this.props.withEdit && this.props.onLabelEditClick}
                                    onClick={this.props.onLabelClick}
                                />)
                            }
                        </div>
                    </div>
                </div>

                {
                    withEdit ? (
                        <div className="popout-foot">
                            <button className="btn btn-link" onClick={this.props.onCreateClick}>+ { t('Create a new tag') }</button>
                        </div>
                    ) : null
                }

                {
                    this.props.onClearClick ? (
                        <div className="popout-foot">
                            <button className="btn btn-link btn-text-warning" onClick={this.props.onClearClick}>{ t('common:Clear') }</button>
                        </div>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default withTranslation(['labels', 'common'])(LabelSelector);
